/**
 * @file 适配ptp-fe-common FormView的申请AppId 入口
 * @author fightingliu
 * @created 2022.04.25
 * @modify 2022.04.27
 */
import React, { forwardRef, useCallback, useState } from 'react';
import { Input } from '@tencent/spaui';
import { APP_ID_APPLY_URL } from 'pages/manage/application/constants';
import '../index.scss';

const ApplyAppId: (props: any, ref: any) => JSX.Element = (props: any) => {
  // 接入formView的组件规范参数value、onChange，从而与formView建立关联
  const { value = [], onChange } = props;
  const [tagAppIdName, setTagAppIdName] = useState(value);
  const handleChange = useCallback(
    (e: any, value: any) => {
      setTagAppIdName(value);
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <div className="isv-fields-input">
      <div className="left">
        <Input placeholder="请输入应用ID" value={tagAppIdName} onChange={(e, value) => handleChange(e, value)} />
      </div>
      <div className="right">
        <div className="divider" />
        <a className="text-active" target="_blank" href={APP_ID_APPLY_URL} rel="noreferrer">
          应用 ID 申请
        </a>
      </div>
    </div>
  );
};
export default forwardRef(ApplyAppId);
